import * as refills from './list'

import { Refill } from '@/types/transactions/refill'

export const allRefills: Refill[] = Object.values(refills).sort(
    (previous, current) => current.date_time.localeCompare(previous.date_time),
)
